import React, { useState, useRef, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getUserOrders } from '../../services/order.service';
import { SidebarLayout } from '../../components/Sidebar';
import {AnimatedActivityChart, CustomDatePicker, DashboardGreetings,DashboardProgress, ExploreGigsCarousel, HellociansCarousel, OngoingProjectCard} from '../../components/components'

const Dashboard = () => {
  const [progress, setProgress] = useState(45);
  const [projectProgress, setProjectProgress] = useState(90);
  const [selectedDate, setSelectedDate] = useState(new Date(2022, 6, 14)); // July 14, 2022
  const exploreGigsRef = useRef(null);
  const topHellocianRef = useRef(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  const { data: ongoingOrdersData, isLoading: ongoingLoading } = useQuery({
    queryKey: ['orders', 'ongoing'],
    queryFn: () => getUserOrders({ type: 'purchases' })
  });

  const activeOrders = (ongoingOrdersData?.orders || []).filter(
    order => order.status === 'pending' || order.status === 'in-progress'
  );

  // Handle window resize to determine desktop or mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Mock data
  const topHellocians = [
    {
      id: 1,
      name: 'Curious George',
      role: 'UI UX Designer',
      avatar: '/path/to/avatar1.jpg',
      tasks: 40,
      rating: 4.7,
      reviews: 20
    },
    {
      id: 2,
      name: 'Abraham Lincoln',
      role: 'Web developer',
      avatar: '/path/to/avatar2.jpg',
      tasks: 32,
      rating: 4.9,
      reviews: 10
    }
  ];

 
 

  // Animated progress effect
  useEffect(() => {
    const timer = setInterval(() => {
      const increment = Math.random() * 5 - 2.5;
      setProgress(prev => {
        const newProgress = Math.max(0, Math.min(100, prev + increment));
        return Math.round(newProgress);
      });
      
      const projectIncrement = Math.random() * 3 - 1;
      setProjectProgress(prev => {
        const newProgress = Math.max(0, Math.min(100, prev + projectIncrement));
        return Math.round(newProgress);
      });
    }, 3000);
    
    return () => clearInterval(timer);
  }, []);

  // Scroll handlers for horizontal scrolling
  const scroll = (ref, direction) => {
    if (ref.current) {
      const scrollAmount = 300; // Adjust scroll amount as needed
      ref.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  // Format date manually (no date-fns)
  const formatDate = (date) => {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  // Generate days for calendar
  const generateCalendarDays = () => {
    const days = [];
    const currentMonth = selectedDate.getMonth();
    const currentYear = selectedDate.getFullYear();
    
    // Show only days 10-15 for simplicity
    for (let i = 10; i <= 15; i++) {
      const date = new Date(currentYear, currentMonth, i);
      days.push({
        date,
        dayOfMonth: i,
        isSelected: i === selectedDate.getDate()
      });
    }
    
    return days;
  };

  const calendarDays = generateCalendarDays();

  return (
    <SidebarLayout currentPath="/dashboard">
    <div className="bg-[#FAFAFA] dark:bg-[#0b0e14] min-h-screen font-['Poppins'] w-full">
      <div className="w-[95%] mx-auto  h-full my-5 flex flex-col md:flex-row items-start gap-4">
       {/* Rights side */}
       <div className="w-full md:w-[70%] flex flex-col gap-3 ">
          <DashboardGreetings/>
          <div className="flex flex-col md:flex-row items-start gap-3">
            <DashboardProgress/>
            <AnimatedActivityChart/>
          </div>
          <HellociansCarousel/>
          <ExploreGigsCarousel/>
       </div>


       {/* Left side */}
       <div className="w-full md:w-[30%] flex flex-col gap-3">
        <CustomDatePicker/>
        <OngoingProjectCard orders={activeOrders} isLoading={ongoingLoading} />
       </div>

      </div>
  
    </div>
    </SidebarLayout>
  );
};

export default Dashboard;